export const PRACTICE_AREA_KEYS = [
  'divorce', 'alimony', 'inheritance', 'debt_collection', 'fraud',
  'ban_check', 'tax', 'business', 'credit', 'labor',
  'traffic_accident', 'traffic_fine', 'cadastre', 'hoa',
  'housing_compensation', 'construction', 'subsidy', 'corporate', 'criminal',
  'administrative', 'property_division', 'intellectual_property',
  'consumer_rights', 'other',
];
